export default __webpack_public_path__ + "static/media/thankYou.f6027a27.png";